'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';

export default function Home() {
  const router = useRouter();

  useEffect(() => {
    const token = typeof window !== 'undefined' ? localStorage.getItem('vet_token') : null;
    if (token) {
      router.replace('/dashboard' as any);
    } else {
      router.replace('/login' as any);
    }
  }, [router]);

  return (
    <div className="min-h-screen auth-bg flex items-center justify-center">
      <div className="flex flex-col items-center gap-4 animate-fade-up">
        <div className="w-10 h-10 border-2 border-blue-500/30 border-t-blue-500 rounded-full animate-spin" />
        <p className="text-slate-400 dark:text-slate-500 text-sm font-medium">Redirecting...</p>
      </div>
    </div>
  );
}
